const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6858"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157511",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6169",
    d: "M188-766.617v-9.959l-2.923 2.923-1.25-1.286 5.065-5.061 5.061 5.061-1.25 1.286-2.923-2.923v9.959zm-5.859 4.4a2.069 2.069 0 0 1-1.521-.622 2.069 2.069 0 0 1-.62-1.521v-3.215h1.778v3.215a.348.348 0 0 0 .114.251.348.348 0 0 0 .251.114h13.5a.348.348 0 0 0 .251-.114.348.348 0 0 0 .114-.251v-3.215h1.778v3.215a2.069 2.069 0 0 1-.622 1.521 2.069 2.069 0 0 1-1.521.622z",
    transform: "translate(-174.892 784.246)",
    style: {
      fill: "#030814"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.2b92d427b056aafee0577c4bd90da2cb.svg";
export { ForwardRef as ReactComponent };